import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ba334152fd3e2ae3dbda3c0abed4e63c.jpg"
          alt="Premium sofa bed living room"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/35 to-black/10" />
      </div>

      {/* Content */}
      <div
        className={`relative z-10 h-full flex flex-col justify-center px-8 md:px-20 max-w-3xl transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-white/70 text-xs tracking-[0.3em] uppercase mb-5 font-medium">
          Sofa Bed Specialists — Phoenix, AZ
        </p>
        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Sofa by Day.<br />
          <em className="not-italic text-[#d4b896]">Bed by Night.</em>
        </h1>
        <p className="text-white/75 text-lg md:text-xl mb-10 leading-relaxed max-w-lg">
          Premium sofa beds from $159 — comfort and style that transforms your space without compromise.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/products"
            className="whitespace-nowrap px-8 py-4 bg-[#8B6348] text-white text-sm font-medium tracking-wider rounded-full hover:bg-[#7a5540] transition-colors duration-200 cursor-pointer text-center"
          >
            Shop Sofa Beds
          </Link>
          <Link
            to="/collections"
            className="whitespace-nowrap px-8 py-4 border border-white/50 text-white text-sm font-medium tracking-wider rounded-full hover:bg-white/10 transition-colors duration-200 cursor-pointer text-center"
          >
            Browse Collections
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-white/30" />
      </div>
    </section>
  );
}
